import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'The kind of source document an engagement charter component represents.',
    name: 'Engagement Charter Component Kind',
    partialId: PartialId.Standard.create('engagement_charter_component_kind'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
